import styled from 'styled-components'
import { css } from 'styled-components'

import { ReactComponent as Pools } from '../../../assets/svg/icons/Pools.svg'

export const PageWrapper = styled.div`
  display: flex;
  width: contain;
  flex-direction: column;
  align-items: start;
  justify-content: flex-start;
`

export const Switch = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
  margin-bottom: 16px;
  width: auto;
  padding: 6px 4px;
  border-radius: 6px;
  height: 36px;
  background: ${({ theme }) => theme.cardSecondary};
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  display: flex;
  align-items: center;
  justify-content: center;

  /* Add these properties for proper scrolling */
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Edge */
  }

  /* Ensure inner content doesn't wrap */
  white-space: nowrap;
`

export const SortIconWrapper = styled.span<{ active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  opacity: ${({ active }) => (active ? 1 : 0.6)};
  transition: opacity 0.2s ease;

  svg {
    display: block;
    width: 16px;
    height: 16px;
  }
`

export const Option = styled.div`
  display: inline-block;
  width: contain;
  cursor: pointer;
  padding: 4px 8px;
  text-align: center;
  gap: 4px;
  border-radius: 3px;
  white-space: nowrap;
  flex-shrink: 0;
  background: transparent;
  color: ${({ theme }) => theme.textSecondary};
  transition: background-color 0.1s ease, color 0.1s ease;

  &.active {
    background: ${({ theme }) => theme.cardPrimary};
    color: ${({ theme }) => theme.textPrimary};
    pointer-events: none;
  }
`

// export const Option = styled.div<{ active: boolean }>`
//   display: inline-block;
//   width: contain;
//   cursor: pointer;
//   padding: 4px 8px;
//   text-align: center;
//   gap: 4px;
//   border-radius: 3px;
//   white-space: nowrap;
//   flex-shrink: 0;
//   background: ${({ active, theme }) => (active ? theme.cardPrimary : 'transparent')};
//   color: ${({ active, theme }) => (active ? theme.textPrimary : theme.textSecondary)};
//   pointer-events: ${({ active }) => active && 'none'};
// `

export const ListContentWrapper = styled.main`
  background-color: ${({ theme }) => theme.cardPrimary};
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.09);
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // ${({ theme }) => theme.mediaWidth.upToMedium`
  //   overflow-x: auto;
  //   -webkit-overflow-scrolling: touch;
  //   scrollbar-width: none;
  //   min-width: 900px;
  //   width: 100%;
  //   &::-webkit-scrollbar {
  //     display: none;
  //   }
  // `}
`

export const LeftAlignedHeaderCol = styled.div<{ helpCursor?: boolean }>`
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: flex-start;
  margin-left: 62px;
  .title {
    ${({ helpCursor = false }) => helpCursor && 'cursor: help;'}
  }
`

export const HeaderCol = styled.div<{ helpCursor?: boolean }>`
  display: flex;
  overflow: hidden;
  align-items: center;
  justify-content: center;
  .title {
    ${({ helpCursor = false }) => helpCursor && 'cursor: help;'}
  }
`

// Subgrid for header
export const HeaderRow = styled.div`
  grid-area: header; // Assign to the header area of parent grid
  display: grid;
  grid-template-columns: 240px 1fr 1fr 90px 200px 90px;
  overflow: hidden;
  border-bottom: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  padding: 8px 16px;
  height: 60px;

  // ${({ theme }) => theme.mediaWidth.upToMedium`
  //   grid-template-columns: 200px 3fr 0px 1fr 200px 90px;
  // `};

  // ${({ theme }) => theme.mediaWidth.upToSmall`
  //   grid-template-columns: 200px repeat(4, 0) 120px;
  // `};

  /* padding: 8px 16px 0 16px; */
  /* grid-template-areas: 'header1 header2 header3 header4 header5 header6'; */
`

// Subgrid for body
export const BodyRow = styled.div`
  grid-area: body; // Assign to the body area of parent grid
  display: grid;
  grid-template-columns: subgrid; // Inherit columns from parent grid
  /* grid-template-areas: 'body1 body2 body3 body4 body5 body6'; */
  height: 60px;
`

// Subgrid for footer
export const FooterRow = styled.div`
  grid-area: footer; // Assign to the footer area of parent grid
  display: grid;
  grid-template-columns: subgrid; // Inherit columns from parent grid
  /* grid-template-areas: 'footer1 footer2 footer3 footer4 footer5 footer6'; */
  height: 60px;
`

export const FlexRowCenter = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const FlexCol = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow: hidden;
`

export const ErrorContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: auto;
  padding: 24px 0;
  max-width: 300px;
`

export const IconStyle = css`
  width: 40px;
  height: 40px;
  margin-bottom: 0.5rem;
`

export const InboxIcon = styled(Pools)`
  ${IconStyle}
`

export const SortableHeaderCol = styled(HeaderCol)`
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.7;
  }

  .title {
    display: flex;
    align-items: center;
  }

  .sort-arrow {
    margin-left: 4px;
    font-size: 12px;
  }
`

export const TableWrapper = styled.div`
  position: relative;
  overflow-x: auto;
  border-radius: 16px;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling for iOS */
  touch-action: auto;

  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera */
  }

  & > table {
    width: 100%;
    min-width: 750px;
  }

  thead {
    position: -webkit-sticky; /* Safari */
    background: ${({ theme }) => theme.cardPrimary};
    height: auto;
    box-sizing: border-box;
    display: table-header-group;
    border-bottom: 1px solid ${({ theme }) => theme.cardBorderPrimary};
  }

  th {
    white-space: nowrap;
    padding: 16px;
    background: ${({ theme }) => theme.cardPrimary};
  }

  td {
    white-space: nowrap;
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  min-width: 750px;
`

export const Th = styled.th<{ sortable?: boolean; active?: boolean; width?: string }>`
  box-sizing: border-box;
  margin: 0px;
  width: ${({ width }) => width || 'auto'};
  min-width: ${({ width }) => width || '100px'};
  font-weight: 700;
  font-size: 16px;
  color: ${({ theme, active }) => (active ? theme.textPrimary : theme.textSecondary)};
  line-height: 24px;
  padding: 12px 16px;
  vertical-align: middle;
  position: relative;
  // background-color: ${({ theme, active }) => (active ? `${theme.cardBorderSecondary} !important` : 'transparent')};

  ${({ sortable, theme }) =>
    sortable &&
    css`
      cursor: pointer;

      &:hover {
        color: ${theme.textPrimary};
        // background-color: ${theme.cardSecondary};
      }

      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    `}
`

export const Td = styled.td`
  padding: 8px 16px;
  color: white;
  font-variant-numeric: tabular-nums;
  text-align: center;
  vertical-align: middle;

  font-weight: 500;

  ${({ theme }) => theme.mediaWidth.upToMedium`

   &:nth-child(2) {
    min-width: 190px;
}


  `}
`
